var map = {
	"./icon-social-email": [
		"3LpY",
		2
	],
	"./icon-social-email/": [
		"3LpY",
		2
	],
	"./icon-social-email/index": [
		"3LpY",
		2
	],
	"./icon-social-email/index.js": [
		"3LpY",
		2
	],
	"./icon-social-facebook": [
		"9ewR",
		2
	],
	"./icon-social-facebook/": [
		"9ewR",
		2
	],
	"./icon-social-facebook/index": [
		"9ewR",
		2
	],
	"./icon-social-facebook/index.js": [
		"9ewR",
		2
	],
	"./icon-social-instagram": [
		"1IWJ",
		98
	],
	"./icon-social-instagram/": [
		"1IWJ",
		98
	],
	"./icon-social-instagram/index": [
		"1IWJ",
		98
	],
	"./icon-social-instagram/index.js": [
		"1IWJ",
		98
	],
	"./icon-social-pinterest": [
		"KSSQ",
		2
	],
	"./icon-social-pinterest/": [
		"KSSQ",
		2
	],
	"./icon-social-pinterest/index": [
		"KSSQ",
		2
	],
	"./icon-social-pinterest/index.js": [
		"KSSQ",
		2
	],
	"./icon-social-twitter": [
		"L374",
		2
	],
	"./icon-social-twitter/": [
		"L374",
		2
	],
	"./icon-social-twitter/index": [
		"L374",
		2
	],
	"./icon-social-twitter/index.js": [
		"L374",
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "z/zq";
module.exports = webpackAsyncContext;